import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './main.component';
import { RouterModule } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [MainComponent],
providers: [ApiService]
})
export class MainModule { }
